const StaticScreenPositions = {
    AfterLevel: 0,
    AfterScreen: 64,
    AfterPuzzleSplash: 100,
    AfterTitle: 101,
    AfterEndScreen: 102,
    AfterCreditsScreen: 103,
    Unused: 255
}

const niceNames = {
    0: "After Level",
    64: "After Screen",
    100: "After Puzzle Maker Screen",
    101: "After Title Screen",
    102: "After Ending Screen",
    103: "After Credits Screen",
    255: "Unused"
};

export default StaticScreenPositions;

export function getScreenPositionFromKey(key) {
    return Object.keys(StaticScreenPositions).find(k => StaticScreenPositions[k] === key);
}

export function getScreenPositionName(key) {

    return niceNames[key] ?? niceNames[StaticScreenPositions[key]];
}

export function getScreenShowAtDetail(key, detail, screens) {
    let value = niceNames[key];
    if (key < 64) {
        return value + ' ' + (detail + 1);
    } else if (key < 100) {
        let theScreen = null;
        if (screens && screens.length) {
            theScreen = screens.find(a => a.id === detail)
        }
        if (theScreen) {
            value += ' (' + theScreen.title + ')';
        } else {
            value = niceNames[255];
        }
    }
    return value;
}